// Success.jsx - 無料版専用安全版（プレミアム要素完全削除）

import React from 'react';

const Success = () => {
  // プレミアム機能は一時的に完全無効化
  const PREMIUM_FEATURES_ENABLED = false;

  const handleReturnToApp = () => {
    // アプリのメイン画面に戻る
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="text-center">
          {/* ヘッダー */}
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <span className="text-2xl">✅</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              操作が完了しました
            </h1>
            <p className="text-gray-600">
              ありがとうございます
            </p>
          </div>

          {/* 現在のプラン状態 */}
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
            <h2 className="font-semibold text-green-800 mb-2">
              📱 無料プラン
            </h2>
            <div className="text-sm text-green-700 space-y-1">
              <div><strong>利用可能機能:</strong></div>
              <div className="flex items-center justify-center">
                <span className="text-green-600">✅</span>
                <span className="ml-2">1日3回のAI投稿生成</span>
              </div>
              <div className="flex items-center justify-center">
                <span className="text-green-600">✅</span>
                <span className="ml-2">高品質AI生成 (GPT-3.5-turbo)</span>
              </div>
              <div className="flex items-center justify-center">
                <span className="text-green-600">✅</span>
                <span className="ml-2">APIキー設定不要</span>
              </div>
              <div className="flex items-center justify-center">
                <span className="text-green-600">✅</span>
                <span className="ml-2">品質評価機能</span>
              </div>
            </div>
          </div>

          {/* 使い方案内 */}
          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h3 className="font-semibold text-blue-800 mb-2">
              🚀 今すぐ始めましょう
            </h3>
            <div className="text-sm text-blue-700 space-y-1">
              <div>1. 投稿のテーマを入力</div>
              <div>2. お好みのトーンを選択</div>
              <div>3. AI が高品質な投稿を生成</div>
              <div>4. コピーしてSNSに投稿</div>
            </div>
          </div>

          {/* 今後の機能について */}
          {!PREMIUM_FEATURES_ENABLED && (
            <div className="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
              <div className="flex items-center justify-center mb-2">
                <span className="text-gray-600">🚧</span>
                <span className="ml-2 text-sm text-gray-700 font-medium">
                  追加機能開発中
                </span>
              </div>
              <p className="text-xs text-gray-600">
                より便利な機能を開発中です。<br />
                アップデートをお楽しみに！
              </p>
            </div>
          )}

          {/* アクションボタン */}
          <div className="space-y-3">
            <button
              onClick={handleReturnToApp}
              className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-green-700 transition-colors"
            >
              🎯 投稿生成を始める
            </button>
            
            <div className="text-center">
              <p className="text-xs text-gray-500">
                無料版で今すぐ高品質なAI投稿生成をお試しください
              </p>
            </div>
          </div>

          {/* サポート情報 */}
          <div className="mt-6 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              ご質問やフィードバックがございましたら<br />
              <a href="mailto:numaken@gmail.com" className="text-blue-600 hover:underline">
                numaken@gmail.com
              </a>
              までお気軽にご連絡ください
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
